<template>
  <v-container>
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card class="py-4">
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-icon color="warning" size="105"> mdi-alert </v-icon>
            </v-col>
            <v-col cols="8">
              <div class="py-2">
                <div class="text-md-h6 font-weight-bold">
                  Your Session is about to expire!
                </div>
                <div>
                  You will be logged out in
                  <span class="text-h6 font-weight-bold">{{ countdown }}</span>
                  seconds
                </div>
                <div>Do you want to stay signed in?</div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" elevation="0" @click="extendLoginSession">
            Yes, Keep me signed in
          </v-btn>
          <v-btn color="error" elevation="0" outlined @click="logout">
            No, Sign me out
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  AUTH_SESSION_MSG,
  subscribeAuthSession,
} from '@/services/auth-session-channel';

export default {
  name: "SignInSession",
  data() {
    return {
      dialog: false,
      countdown: Number.MAX_SAFE_INTEGER,
      setTime: 60,
      unsubscribeAuthSession: null,
    };
  },
  created() {
    let timerId = setInterval(() => {
      this.countdown = this.$store.getters["auth/getRemainingSessionTime"](
        Date.now()
      );

      if (
        this.countdown > 0 &&
        this.countdown <= this.setTime &&
        this.dialog === false
      ) {
        this.dialog = true;
      }

      if (this.$store.getters["auth/getRemainingSessionTime"](Date.now()) < 1) {
        this.init();
        this.logout();
      }
    }, 1000);

    this.$store.commit('auth/setSessionId', timerId);

    this.unsubscribeAuthSession = subscribeAuthSession((message) => {
      if (message.type === AUTH_SESSION_MSG.AUTH_CHANGED) {
        let user = null;
        try {
          user = JSON.parse(localStorage.getItem('user'));
        } catch (e) {
          console.error('Invalid auth user in localStorage', e);
          this.$store.dispatch('auth/logout');
          return;
        }
        if (!user?.accessToken) {
          this.$store.dispatch('auth/logout');
          return;
        }
        this.$store.commit('auth/syncUser', user);
        this.$store.dispatch('auth/getNavMenuList');
        this.init();
      } else if (message.type === AUTH_SESSION_MSG.LOGOUT) {
        this.$store.dispatch('auth/logout');
      }
    });
  },
  beforeDestroy() {
    if (this.unsubscribeAuthSession) {
      this.unsubscribeAuthSession();
      this.unsubscribeAuthSession = null;
    }
  },
  methods: {
    init() {
      this.dialog = false;
      this.countdown = Number.MAX_SAFE_INTEGER;
    },
    logout() {
      this.$store.dispatch('auth/logout');
      location.reload();
    },
    async extendLoginSession() {
      try {
        await this.$store.dispatch(
          "auth/switchUserProfile",
          this.$store.state.auth.user
        );
        this.init();
      } catch (e) {
        console.error("Error extending login session", e);
      }
    },
  },
};
</script>
